import images1 from './images/first';
import images2 from './images/second';

import type { CollectionBenefitData } from './CollectionBenefit';

const data: CollectionBenefitData[] = [
  {
    backgroundColor: '#e9edec',
    textAlignment: 'right',
    images: {
      sheet: images1.sheet,
      bedLinens: [
        { src: images1.bedLinen1 },
        { src: images1.bedLinen2 },
        { src: images1.bedLinen3 },
      ],
      blobs: [
        { src: images1.blob1, group: 1, width: 33, top: -5, left: -25, rotate: true },
        { src: images1.blob2, group: 1, width: 39, bottom: 18, right: -18 },
        { src: images1.blob3, group: 2, width: 20, top: 30, left: -25 },
        { src: images1.blob4, group: 2, width: 37, bottom: -10, left: 15 },
        { src: images1.blob5, group: 3, width: 16, bottom: 12, right: 31 },
        { src: images1.blob6, group: 3, width: 40, bottom: -7, right: -8 },
        { src: images1.blob7, group: 3, width: 50, bottom: -2, left: -25, rotate: true },
      ],
    },
    link: '/category/promo-pick-and-pair',
  },
  {
    backgroundColor: '#FFDCC9',
    textAlignment: 'left',
    images: {
      sheet: images2.sheet,
      bedLinens: [
        { src: images2.bedLinen1 },
        { src: images2.bedLinen2 },
        { src: images2.bedLinen3 },
      ],
      blobs: [
        { src: images2.blob1, group: 1, width: 41, top: 10, right: -65 },
        { src: images2.blob2, group: 1, width: 35, bottom: -10, right: -65 },
        { src: images2.blob3, group: 2, width: 48, top: -28, right: -17 },
        { src: images2.blob4, group: 2, width: 31, bottom: 32, right: -28 },
        { src: images2.blob5, group: 3, width: 43, top: 5, left: -30, behind: true },
        { src: images2.blob6, group: 3, width: 46, bottom: -10, left: -17 },
      ],
    },
    link: '/category/promo-pick-and-pair',
  },
];

export default data;
